<template>
  <div class="toggle">
    <slot />
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
.toggle {
  background-color: #ebebeb;
  border-radius: 12px;
  display: flex;
  padding: 0.25rem;
  // margin-bottom: 1rem;
  user-select: none;
  flex-wrap: wrap;
  justify-content: center;

  p {
    display: block;
    color: #B9BFC5;
    margin-bottom: 2px;
    overflow: hidden;
    white-space: nowrap;
    color: #767676;
    font-size: 0.8rem;
    line-height: 1.25rem;
    text-align: center;
    padding: .3rem .75rem;
    line-height: 1.25rem;
    font-weight: 400;
    text-align: center;

    &:hover {
      cursor: pointer;
    }

    @media (min-width: 1024px) {
      // font-size: 1rem;
      // line-height: 1.5rem;
      padding: .25rem 1.5rem;
    }

    &.active {
      background-color: #FFFFFF;
      box-shadow: 0 0 1px 0 rgb(0 0 0 / 8%), 0 1px 1px 0 rgb(0 0 0 / 6%), 0 2px 1px 0 rgb(0 0 0 / 4%), 0 3px 1px 0 rgb(0 0 0 / 4%);
      border-radius: 8px;
      color: #0060FF;
    }
  }
}
</style>
